import BucketListView from './BucketListView';
import './BucketListView.scss';

export default BucketListView;
